import React from 'react'
// MUI

import { useTheme } from '@mui/material/styles'
import { BLOCKS, RenderNode } from '../../../RichText/types'
import RichText, { IRichText } from '../../../RichText'
import Typography from '@mui/material/Typography'
import { HelpPageListComponentProps } from './HelpPageList.type'

const HelpPageList = ({ list, startNumber }: HelpPageListComponentProps) => {
  const theme = useTheme()

  const renderNode: Partial<RenderNode> = {
    [BLOCKS.HEADING_2]: (node, children) => {
      const element = (
        <Typography component="h2" variant={'h5'} sx={styles.h2}>
          {children}
        </Typography>
      )
      return element
    },
  }
  const styles = {
    list: {
      '& ol': {
        padding: 0,
        counterSet: `styled-counter ${startNumber && startNumber - 1}`,
        '& > li': {
          counterIncrement: 'styled-counter',
          listStyle: 'none',
          marginBottom: '16px',
          paddingLeft: '48px',
          position: 'relative',
          '&:last-child': {
            marginBottom: 0,
          },
          '& > *': {
            display: 'block',
            '&:last-child': {
              marginBottom: 0,
            },
          },
          '&:before': {
            content: 'counter(styled-counter)',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            display: 'inline-flex',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
          },
        },
      },
    },
    h2: {
      scrollMarginTop: '80px',
      marginBottom: '.5em',
      wordBreak: 'break-word',
      '&:only-child': {
        marginTop: '-5px',
      },
      '&:first-child': {
        marginTop: 0,
      },
    },
  }
  return <RichText {...(list as IRichText)} renderNode={renderNode} sx={styles.list} />
}

export default HelpPageList
